import Link from 'next/link';

export function Footer() {
  return (
    <footer className="border-t border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-sm text-slate-600 dark:text-slate-300">
            © <time dateTime="2026">2026</time> CommitShift · Caen, France
          </p>

          <nav
            aria-label="Liens juridiques"
            className="flex items-center gap-2 text-sm"
          >
            <Link
              href="/mentions-legales"
              className="text-sky-700 dark:text-sky-400 hover:underline"
            >
              Mentions légales
            </Link>
            <span aria-hidden="true" className="text-slate-400">
              ·
            </span>
            <Link
              href="/politique-de-confidentialite"
              className="text-sky-700 dark:text-sky-400 hover:underline"
            >
              Politique de confidentialité
            </Link>
            <span aria-hidden="true" className="text-slate-400">
              ·
            </span>
            <Link
              href="/cgv"
              className="text-sky-700 dark:text-sky-400 hover:underline"
            >
              CGV
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
